module.exports = __webpack_public_path__ + "img/bg_10_zh.844d8247.png";